import { Change, getChangeType } from "@/apis/user";
import { PAGE_SIZE } from "@/constants/config";
import { useUserChangeStore } from "@/stores/user/useUserChangeStore";
import { ChangeAmount, FetchUserChangeParams } from "@/types/Api/User/change";
import { useInfiniteScroll } from "ahooks";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
const getInitialParams = () => {
  return {
    page: 1,
    pageSize: PAGE_SIZE,
    startTime: dayjs().format("YYYY-MM-DD 00:00:00"),
    endTime: dayjs().format("YYYY-MM-DD 23:59:59"),
  };
};
export const useLogic = () => {
  const store = useUserChangeStore();
  const [params, setParams] = useState<Partial<FetchUserChangeParams>>(() =>
    getInitialParams()
  );

  const scollableRef = useRef(null);
  const paramsRef = useRef({});
  const infiniteList = useInfiniteScroll<{
    list: ChangeAmount[];
    total: number;
  }>(
    async (d) => {
      const page = d ? Math.ceil(d.list.length / PAGE_SIZE) + 1 : 1;
      const newParams = { ...paramsRef.current, page, pageSize: PAGE_SIZE };
      const response = await Change(newParams);
      if (response.ok) {
        setParams(newParams);
      }
      return {
        list: response.data?.list ?? [],
        total: response.data?.total ?? 0,
      };
    },
    {
      manual: true,
      target: scollableRef,
      isNoMore: (d) => d?.total === 0 || d?.total === d?.list.length,
    },
  );

  const fetchChangeTypeMap = async () => {
    await store.fetchChangeTypeMap(getChangeType);
  };

  useEffect(() => {
    fetchChangeTypeMap();
  }, []);
  return {
    infiniteList,
    params,
    scollableRef,
    paramsRef,
    setParams,
    changeTypeMap: store.changeTypeMap,
  };
};
